/**
 * Layout-Affecting Scrollbar Detection
 * Detects scrollbars that consume layout space (not overlay scrollbars)
 * Adds body class and CSS custom property with scrollbar width
 */
( function() {
	function detectLayoutScrollbar() {
		const body = document.body;
		const root = document.documentElement;

		// Calculate scrollbar width by comparing viewport width to content width
		// If there's a difference, the scrollbar is consuming layout space
		const scrollbarWidth = window.innerWidth - root.clientWidth;

		// Set CSS custom property with the scrollbar width value
		root.style.setProperty( '--scrollbar-width', scrollbarWidth + 'px' );

		// Add/remove body class based on whether scrollbar affects layout
		if ( scrollbarWidth > 0 ) {
			body.classList.add( 'has-layout-scrollbar' );
		} else {
			body.classList.remove( 'has-layout-scrollbar' );
		}
	}

	// Run on page load
	detectLayoutScrollbar();

	// Run on window resize
	window.addEventListener( 'resize', detectLayoutScrollbar );

	// Run when DOM content changes (for dynamic content that might add scrollbar)
	const observer = new MutationObserver( detectLayoutScrollbar );
	observer.observe( document.body, {
		childList: true,
		subtree: true
	} );

}() );
